import type { ReportInvoiceFile } from 'ap-openapi';

/**
 * Type guard to check if data is a ReportInvoiceFile
 */
export const isReportInvoiceFile = (
  data: unknown
): data is ReportInvoiceFile => {
  return Boolean(
    data && typeof data === 'object' && 'id' in data && 'name' in data
  );
};

/**
 * Type guard to check if value is a Record
 */
export const isRecord = (value: unknown): value is Record<string, unknown> => {
  return value !== null && typeof value === 'object';
};

/**
 * Type guard to check if value is a valid scan decision
 */
export const isValidScanDecision = (
  value: unknown
): value is 'warning' | 'error' | 'ok' => {
  return (
    typeof value === 'string' && ['warning', 'error', 'ok'].includes(value)
  );
};

/**
 * Helper function to safely get string value
 */
export const getString = (value: unknown): string =>
  typeof value === 'string' ? value : '';
